export default __webpack_public_path__ + "static/media/resultPushM.7fbb3e37.png";